import { render, staticRenderFns } from "./view_quarantine.vue?vue&type=template&id=6599553a&"
import script from "./view_quarantine.vue?vue&type=script&lang=js&"
export * from "./view_quarantine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports